import React from "react";
import { Edit } from "@mui/icons-material";
import { Colors } from "../../../../constants/Colors";
import { Vehicle } from "../../../../types/vehicles.types";
import { editVehicleEffect } from "../../../../stores/VehiclesStore/VehiclesStore.effects";
import VehicleFormModal from "../VehicleFormModal/VehicleFormModal";

interface Props {
  vehicle: Vehicle;
}

const EditVehicle: React.FC<Props> = ({ vehicle }) => {
  return (
    <VehicleFormModal
      isEdit
      vehicle={vehicle}
      effect={editVehicleEffect}
      title="Editar veículo"
      confirmText="Confirmar"
      cancelText="Cancelar"
      TriggerComponent={
        <Edit
          sx={{ color: Colors.primary[100], ":hover": { opacity: "70%" }, cursor: "pointer" }}
        />
      }
    />
  );
};

export default EditVehicle;
